// third-party
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

// project imports
import axios from 'utils/axios';
import { openSnackbar } from 'store/slices/snackbar';

// types
import { DefaultRootStateProps, VademecumProduct } from 'types';
import { VADEMECUM_URL } from 'config';

const initialState: DefaultRootStateProps['vademecum'] = {
    loading: true,
    infoVademecumProduct: {} as VademecumProduct
};

const slice = createSlice({
    name: 'vademecum',
    initialState,
    reducers: {},
    extraReducers(builder) {
        builder
            .addCase(getInfoVademecum.pending, (state) => {
                state.loading = true;
            })
            .addCase(getInfoVademecum.fulfilled, (state, action) => {
                state.loading = false;

                if (action.payload && !Object.keys(action.payload).length) {
                    state.infoVademecumProduct = {} as VademecumProduct;
                    return;
                }

                function removeEmptyProperties(obj: object) {
                    return Object.entries(obj).reduce((acc: any, [key, value]) => {
                        if (typeof value === 'string' && value.trim() !== '') {
                            acc[key] = value;
                        }
                        return acc;
                    }, {});
                }

                const media = action.payload?.media && removeEmptyProperties(action.payload.media);
                const packageItem = action.payload?.package && removeEmptyProperties(action.payload.package);
                const product = action.payload?.product && removeEmptyProperties(action.payload.product);

                const result = {
                    product,
                    package: packageItem,
                    media
                };
                state.infoVademecumProduct = result;
            })
            .addCase(getInfoVademecum.rejected, (state) => {
                state.loading = false;
            });
    }
});

export const getInfoVademecum = createAsyncThunk(`${slice.name}/getInfoVademecum`, async (ean: string | number, { dispatch }) => {
    try {
        const response = await axios.get(`${VADEMECUM_URL}/api/products/EAN/${ean}`);

        return response.data;
    } catch (error) {
        dispatch(
            openSnackbar({
                message: `An error occurred while fetching Vademecum info`,
                variant: 'error'
            })
        );
    }
});

export default slice.reducer;
